module.exports = __webpack_public_path__ + "static/media/Sliten.54646148.mp3";